import React, { Component } from 'react';
import * as Sentry from "@sentry/react";
import initSentryOnce from "../lib/sentryInit";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };

    initSentryOnce();
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    Sentry.captureException(error);
  }

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
